import User from "@/shared/lib/client-sdk/models/user";
import { portalForHost } from "@/shared/lib/portal-host";

let isRedirecting = false;
let portalRouter = null;

export const setExpiredSessionRouter = (router) => {
  portalRouter = router;
};

// Resolved from the URL rather than currentRoute, which is still the start route while the first page
// load's requests come back.
const isPublicPage = () =>
  Boolean(
    portalRouter?.match(window.location.pathname + window.location.search)?.meta
      ?.allowsAnonymousUser
  );

// Admin and the client portal sign in on the auth portal; the others have their own /login, and only Next
// Level reads a return path. The auth portal is the login page itself, and benefit election never signs in.
export const expiredSessionDestination = (location, authLoginUrl) => {
  switch (portalForHost(location.host)) {
    case "admin":
    case "client":
      return `${authLoginUrl}?returnUrl=${encodeURIComponent(location.href)}`;
    case "accountHolder":
      return `/login?returnUrl=${encodeURIComponent(
        location.pathname + location.search
      )}`;
    case "participant":
    case "advisor":
    case "nationalRegistry":
      return "/login";
    default:
      return null;
  }
};

export const handleExpiredSession = () => {
  const destination = expiredSessionDestination(
    window.location,
    window.amplifyRuntimeConfig.get("VUE_APP_LOGIN_URL")
  );

  // A page fires several requests at once, so every one of them comes back 401.
  if (destination === null || isRedirecting) return;

  if (portalForHost(window.location.host) === "nationalRegistry") {
    User.logoutNationalRegistryAuthenticatedUser();
  } else {
    User.logoutAuthenticatedUser();
  }

  // A public page (a password-reset link, the login page itself) keeps working without the stale sign-in, and
  // leaving it would lose the link's token or nest the login page's return path. The flag stays unset because
  // signing in from here navigates in-app, and a later expiry must still redirect.
  if (isPublicPage() || window.location.pathname.startsWith("/login")) return;

  isRedirecting = true;
  window.location.assign(destination);
};
